/* INITIALIZING */
export const SET_LANG = 'SET_LANG';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';